import React from 'react'
import { renderToString } from 'react-dom/server'
import styled from 'styled-components'

import Alert from 'garden/src/js/components/alert'
import emitter from 'garden/src/js/utils/emitter'

import * as cartRepository from 'scripts/api/cart'

import { tracker } from 'reactUtils/app'

import { colors } from '../../react-components/garden/common/utils/constants'

const { defaultDarker } = colors

const showAlert = ({ title, error }) => {
  const Wrapper = styled.div`
    text-align: left;
  `

  const Title = styled.h1`
    color: ${defaultDarker};
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  `

  const Message = renderToString(
    <Wrapper>
      <Title>{title}</Title>
      <div>
        {error}
        <br />
      </div>
    </Wrapper>
  )

  return new Alert({
    textMessage: Message
  })
}

export default async (data, opts = {}) => {
  try {
    const response = await cartRepository.putProductsInCart(data)

    const body = response.data
    const {
      uniqueProductsCount,
      shippings,
      total,
      subTotal,
      discountTotal,
      services
    } = body
    const cart = {
      uniqueProductsCount,
      total,
      subTotal,
      discountTotal,
      shippings,
      services
    }

    emitter.emit('cart:update', { count: body.uniqueProductsCount })
    emitter.emit('cart:products-added', cart)
    emitter.emit('product:data-layer', {
      storeName: shippings[0].items[0].storeId
    })

    tracker.addToCart(data.products[0], cart)
  } catch (err) {
    showAlert({
      title: 'Ops!',
      error: err.response.data.errors[0]
    })
  }
}
